import { render } from "./MountedTexts.vue?vue&type=template&id=8f8990de&scoped=true"
import script from "./MountedTexts.vue?vue&type=script&lang=js"
export * from "./MountedTexts.vue?vue&type=script&lang=js"

import "./MountedTexts.vue?vue&type=style&index=0&id=8f8990de&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8990de"]])

export default __exports__